import $ from 'jquery';
import Ajax from "shared/ajax";

export default function fetch(url, options, onError) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url,
      success: resolve,
      error: (response) => { reject(onError ? onError(response) : response); },
      data: JSON.stringify(options.body),
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': Ajax.getCsrfToken()
      },
      credentials: 'include',
      ...options
    });
  });
}
